import { genderType } from "redux/commonTypes";
import { photoType, normalizeDatingPurpose } from "../users/usersTypes";
import { actionTypes } from "./profileTypes";

const initialState: profileStateType = {
  idProfile: window.localStorage.idProfile || null,
  email: null,
  countryId: null,
  cityId: 0,
  gender: null,
  interestedGender: null,
  birthday: null,
  name: null,
  age: null, //TODO
  relation: null,
  education: null,
  income: null,
  occupation: null,
  city: null,
  avatar: null,
  aboutMe: "",
  height: null,
  weight: null,
  hair: null,
  eyes: null,
  languages: [],
  children: null,
  interests: [],
  smoking: null,
  alcohol: null,
  publicPhotos: [],
  privatePhotos: [],
  editSuccess: false,
  country: null,
  profileLoading: true,
  isBlockedWithouVerification: false,
  allPhotos: [],
  sexTypes: [],
  isBlockedWithoutAnyPhoto: (() => {
    try { return window.localStorage.getItem("needsMainPhoto") === "1"; } catch (e) { return false; }
  })(),
  idFb: 0,
  idGoogle: 0,
  linkSocialErr: "",
  prevRoute: "", // prevRoute нужен для страницы billing. Потому iframe оплаты открывает новые страницы и history.goBack() работает с 3 раза
  reasonDeletingPhoto: "",
  isAnonymousMe: false,
  avatarForPinned: "",
  gestureVerifyStatus: null,
  photoRejected: false,
  photoRejectReason: null,
  photoRejectUri: null,
  mainPhotoRejected: false,
  verifiedSuccessModal: false,
  femaleVerifyModal: null
};

type profileStateType = {
  idProfile: string | null;
  birthday: null | string;
  name: null | string;
  countryId: null | number;
  cityId: number;
  gender: null | genderType;
  interestedGender: null | genderType;
  email: string | null;
  age: number | null;
  relation: number | null;
  education: string | null;
  income: string | null;
  occupation: number | null;
  city: string | null;
  country: string | null;
  avatar: string | null;
  aboutMe?: string;
  height?: number | null;
  weight?: number | null;
  hair?: string | null;
  eyes?: string | null;
  languages?: Array<number> | null;
  children?: number | null;
  interests?: Array<number> | null;
  smoking?: string | null;
  alcohol?: string | null;
  publicPhotos?: Array<photoType>;
  privatePhotos?: Array<photoType>;
  languagesString?: string;
  interestsString?: string;
  editSuccess: boolean;
  profileLoading: boolean;
  citizenship?: string;
  citizenshipId?: number;
  datingPurpose?: string;
  variabilityBirthday?: boolean;
  variabilityName?: boolean;
  isBlockedWithouVerification: boolean;
  gestureVerifyStatus: number | null;
  photoRejected: boolean;
  photoRejectReason: number | null;
  photoRejectUri: string | null;
  /** отказ главного фото по mainPhotoVerifiedStatus из extended-профиля */
  mainPhotoRejected: boolean;
  /** показать модалку «профиль верифицирован» (один раз после pending) */
  verifiedSuccessModal: boolean;
  /** анти-скам попап: "verify" — пройти верификацию, "pending" — дождитесь проверки */
  femaleVerifyModal: null | "verify" | "pending";
  allPhotos: Array<photoType>;
  sexTypes?: Array<number>;
  breast?: number;
  sexualOrientation?: number;
  periodicity?: number;
  sexTypesString?: string;
  isBlockedWithoutAnyPhoto: boolean;
  idFb: number;
  idGoogle: number;
  linkSocialErr: string;
  reasonDeletingPhoto: string;
  prevRoute?: string;
  isAnonymousMe: boolean;
  avatarForPinned: string;
};

const profileReducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case actionTypes.SET_ME:
      return {
        ...state,
        idProfile: payload.idProfile,
        gender: payload.gender,
        name: payload.name,
        birthday: payload.birthday,
        phone: payload.phone,
        city: payload.city,
        age: payload.age,
        avatar: payload.avatar,
        publicPhotos: payload.publicPhotos,
        privatePhotos: payload.privatePhotos,
        interests: payload.interests,
        languages: payload.languages,
        smoking: payload.smoking,
        alcohol: payload.alcohol,
        income: payload.income,
        occupation: payload.occupation,
        education: payload.education,
        hair: payload.hair,
        eyes: payload.eyes,
        height: payload.height,
        weight: payload.weight,
        countryId: payload.countryId,
        cityId: payload.cityId,
        interestsString: payload.interestsString,
        languagesString: payload.languagesString,
        aboutMe: payload.aboutMe,
        country: payload.country,
        citizenship: payload.citizenship,
        citizenshipId: payload.citizenshipId,
        datingPurpose: normalizeDatingPurpose(payload.datingPurpose),
        variabilityBirthday: payload.variabilityBirthday,
        variabilityName: payload.variabilityName,
        relation: payload.relation,
        allPhotos: [...payload.publicPhotos, ...payload.privatePhotos],
        sexTypes: payload.sexTypes,
        breast: payload.breast,
        sexualOrientation: payload.sexualOrientation,
        periodicity: payload.periodicity,
        sexTypesString: payload.sexTypesString,
        children: payload.children,
        idFb: payload.idFb,
        idGoogle: payload.idGoogle,
      };
    case actionTypes.SET_PROFILE_EXTENDED:
      return {
        ...state,
        idProfile: payload.idProfile,
        gender: payload.gender,
        name: payload.name,
        birthday: payload.birthday,
        city: payload.city,
        age: payload.age,
        countryId: payload.countryId,
        cityId: payload.cityId,
        country: payload.country,
      };
    case actionTypes.SET_BIRTH_DATE:
      return {
        ...state,
        birthday: payload,
      };
    case actionTypes.SET_NAME:
      return {
        ...state,
        name: payload,
      };
    case actionTypes.SET_CITY:
      return {
        ...state,
        cityId: Number(payload),
      };
    case actionTypes.SET_COUNTRY:
      return {
        ...state,
        countryId: Number(payload),
      };
    case actionTypes.SET_GENDER:
      return {
        ...state,
        gender: payload,
      };
    case actionTypes.SET_INTERESTED_GENDER:
      return {
        ...state,
        interestedGender: payload,
      };
    case actionTypes.SET_EMAIL:
      return {
        ...state,
        email: payload,
      };
    case actionTypes.RESET_ALL_PROFILE:
      return {
        ...state,
        countryId: null,
        cityId: 0,
        gender: null,
        birthday: null,
        name: null,
      };
    case actionTypes.SET_EDIT_SUCCESS:
      return {
        ...state,
        editSuccess: payload,
      };
    case actionTypes.SET_PROFILE_LOADING:
      return {
        ...state,
        profileLoading: payload,
      };
    case actionTypes.SET_PUBLIC_PHOTOS:
      return {
        ...state,
        publicPhotos: payload,
      };
    case actionTypes.SET_PRIVATE_PHOTOS:
      return {
        ...state,
        privatePhotos: payload,
      };
    case actionTypes.SET_AVATAR:
      return {
        ...state,
        avatar: payload.avatarUrl,
        avatarForPinned: payload.avatarForPinned
      };
    case actionTypes.SET_VARIABILITY_BIRTHDAY:
      return {
        ...state,
        variabilityBirthday: payload,
      };
    case actionTypes.SET_VARIABILITY_NAME:
      return {
        ...state,
        variabilityName: payload,
      };
    case actionTypes.SET_NOT_VERIFIED:
      return {
        ...state,
        isBlockedWithouVerification: payload,
      };
    case actionTypes.SET_NOT_HAVE_PHOTO:
      return {
        ...state,
        isBlockedWithoutAnyPhoto: payload,
      };
    case actionTypes.SET_FB_ID:
      return {
        ...state,
        idFb: payload,
      };
    case actionTypes.SET_GOOGLE_ID:
      return {
        ...state,
        idGoogle: payload,
      };
    case actionTypes.SET_LINK_SOCIALS_ERR:
      return {
        ...state,
        linkSocialErr: payload,
      };
    case actionTypes.SET_REASON_DELETING_PHOTO:
      return {
        ...state,
        reasonDeletingPhoto: payload,
      };
    case actionTypes.SET_PREV_ROUTE:
      return {
        ...state,
        prevRoute: payload,
      };
    case actionTypes.SET_GESTURE_VERIFY_STATUS:
      return {
        ...state,
        gestureVerifyStatus: payload,
      };
    case actionTypes.SET_PHOTO_REJECTED:
      return {
        ...state,
        photoRejected: payload.rejected,
        photoRejectReason: payload.reason,
        photoRejectUri: payload.uri,
      };
    case actionTypes.SET_MAIN_PHOTO_REJECTED:
      return {
        ...state,
        mainPhotoRejected: payload,
      };
    case actionTypes.SET_FEMALE_VERIFY_MODAL:
      return {
        ...state,
        femaleVerifyModal: payload,
      };
    case actionTypes.SET_VERIFIED_SUCCESS_MODAL:
      return {
        ...state,
        verifiedSuccessModal: payload,
      };
    case actionTypes.SET_ANONYMOUS_ME:
      return {
        ...state,
        isAnonymousMe: payload,
      };
    default:
      return state;
  }
};

export default profileReducer;
